<template>
  <div>
    <!-- <span class="tips" v-if="!(policyDetail.type == 1 || policyDetail.dockChannel == 3)">提示：录入保单的人员清单，仅为新契约中的人员</span> -->
    <div class="search-box btn3">
      <div class="input-item" v-if="policyDetail.type == 1 || policyDetail.dockChannel == 3">
        <span class="label">状态</span>
        <Radio-group v-model="searchParams.status" @on-change="searchAjax()">
          <Radio label="1">在保</Radio>
          <Radio label="99">全部</Radio>
          <Radio label="0">不在保</Radio>
        </Radio-group>
      </div>
      <div class="input-item">
        <span class="label">被保险人</span>
        <Input v-model="searchParams.condition" placeholder="输入姓名或证件号" clearable />
      </div>
      <div class="btn-item">
        <Button type="primary" @click="searchAjax()">搜索</Button>
        <Button type="primary" ghost @click="resetSearch()">重置</Button>
      </div>
    </div>
    <div class="tools-box">
      <Button type="warning" @click="exportList" v-show="$units.pointAction('order_50_4')">导出</Button>
    </div>
    <div class="table-box">
      <loading :isShow="listLoading" />
      <Table :columns="columns" :data="tableData">
        <template slot-scope="{ row }" slot="cardNoMask">
          <div>
            <span v-if="!row.eyeShow1">{{ row.cardNoMask }}</span>
            <span v-else>{{ row.cardNoMask1 }}</span>
            <span v-if="row.cardNoMask">
              <i class="iconfont iconxianshi eye-icon" v-if="row.eyeShow1" @click="openEye(row, 'eyeShow1', 'cardNoMask')"></i>
              <i class="iconfont iconyincang eye-icon" v-else @click="openEye(row, 'eyeShow1', 'cardNoMask')"></i>
            </span>
          </div>
        </template>
      </Table>
    </div>
    <Page :total="total" :current="pageNum" :page-size="pageSize" show-total @on-change="getList" style="text-align: center" />
  </div>
</template>

<script>
import { pageTool, common } from '@/api/mixins';
export default {
  mixins: [pageTool, common],
  props: {
    operationFunction: null,
    policyDetail: null
  },
  components: {},
  data() {
    return {
      searchParams: {},
      loading: false,
      columns: [
        {
          title: '序号',
          align: 'center',
          width: 80,
          type: 'index'
        },
        {
          title: '姓名',
          key: 'name',
          minWidth: 160,
          align: 'center',
          render(h, params) {
            let status = params.row.status;
            if (status != '' && status == 0) {
              return (
                <p>
                  <span>{params.row.name}</span>
                  <span class="status-box">不在保</span>
                </p>
              );
            } else {
              return <span>{params.row.name}</span>;
            }
          }
        },
        {
          title: '性别',
          key: 'sex',
          minWidth: 160,
          align: 'center',
          render(h, params) {
            return <span>{params.row.sex == '1' ? '男' : '女'}</span>;
          }
        },
        {
          title: '证件号',
          slot: 'cardNoMask',
          minWidth: 160,
          align: 'center'
        },
        {
          title: '职业名称',
          key: 'jobName',
          minWidth: 160,
          align: 'center'
        },
        {
          title: '职业编码',
          key: 'jobCode',
          minWidth: 160,
          align: 'center'
        },
        {
          title: '职业类别',
          key: 'jobGrade',
          minWidth: 160,
          align: 'center'
        },
        {
          title: '保障计划',
          key: 'planName',
          minWidth: 160,
          align: 'center'
        }
      ]
    };
  },
  created() {
    this.tableData = [];
    this.initListAjax('/buz/grouppolicy/page/insures');
  },
  methods: {
    openEye(item, keyName, name) {
      if (!item[keyName]) {
        this.descrypt(
          {
            query: item.id,
            operationFunction: this.operationFunction || 19,
            operationType: 1
          },
          item,
          name + '1',
          'order_50_1'
        ).then(() => {
          this.$set(item, keyName, true);
        });
      } else {
        this.$set(item, keyName, false);
      }
    },
    exportList() {
      this.loading = true;
      let params = JSON.parse(JSON.stringify(this.searchParams));
      this.setListParams(params);
      params.pageNum = this.pageNum;
      params.pageSize = this.pageSize;
      this.$http({
        url: '/buz/grouppolicy/page/insures/export',
        type: 'POST',
        responseType: 'blob',
        data: params,
        apiPermissionCode: 'order_50_4'
      })
        .then(res => {
          this.loading = false;
          this.$units.daochu(res);
        })
        .catch(e => {
          this.loading = false;
        });
    },
    // 转化参数
    setListParams(params) {
      params.policyNo = this.policyDetail.policyNo;
      if (params.status == '99') {
        delete params.status;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.tips {
  color: #515a6e;
  display: block;
  font-size: 14px;
  margin-bottom: 10px;
}
.search-box {
  padding-right: 250px;
}

.tools-box {
  display: flex;
  justify-content: flex-end;
}

/deep/.status-box {
  display: inline-block;
  border: 1px solid #999;
  color: #999;
  margin-left: 8px;
  font-size: 10px;
  padding: 4px;
  line-height: 10px;
}
.eye-icon {
  cursor: pointer;
  margin-left: 5px;
}
</style>
